import type { GeneralParameters } from '../../general/parameters/general'
import type { UiActionParameters } from '../parameters/ui-action'

import { Analytix } from '~/shared/analytix'
import { AnalytixEvent } from '../../general/event'
import { Gate, seeds } from '../../general/gate'

export abstract class UiActionEvent extends AnalytixEvent<UiActionParameters> {
  name = 'ui_action'
  group = null
  sender = Analytix.prototype.sendUIActionEvent

  // `ui_action` event uses session gate to ensure that it is not emitted before session is started
  gates = [Gate.Uses(seeds.session)]

  private params: UiActionParameters

  constructor(params: UiActionParameters) {
    super()

    this.params = params
    this.verify()
  }

  /**
   * Validate required parameters for `ui_action` event.
   */
  validate(): false | [GeneralParameters, UiActionParameters] {
    return [
      Object.fromEntries(this.general),
      {
        ...Object.fromEntries(this.parameters), // default parameters for 'ui_action'
        ...this.params, // parameters, given at construction time
      },
    ]
  }
}
